module.exports = __webpack_public_path__ + "img/monolisa-dark.e7683db7.png";